// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * PlatformAdmin — panel de plataforma de la CMDB (solo superadmin).
 * Solo variables del design system (dark + light).
 */

.platform-admin {
  padding: 22px 26px 40px;
  max-width: 1240px;
  margin: 0 auto;
}

.pa-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.pa-title {
  margin: 0 0 4px;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
}

.pa-subtitle {
  margin: 0;
  font-size: 0.88rem;
  color: var(--text-secondary);
  max-width: 640px;
}

.pa-summary {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.pa-summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 96px;
  padding: 8px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-card);
}

.pa-summary-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--accent);
  font-variant-numeric: tabular-nums;
}

.pa-summary-label {
  font-size: 0.7rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  text-align: center;
}

.pa-tabs {
  display: flex;
  gap: 6px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.pa-tab {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--text-secondary);
  font-size: 0.88rem;
  font-weight: 600;
  padding: 9px 14px;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.pa-tab:hover {
  color: var(--text-primary);
}

.pa-tab--active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.pa-pending,
.pa-denied {
  border: 1px dashed var(--border);
  border-radius: 12px;
  padding: 26px 24px;
  background: var(--bg-card);
  color: var(--text-secondary);
}

.pa-denied {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  margin-top: 40px;
}

.pa-denied svg {
  width: 34px;
  height: 34px;
  color: var(--text-muted);
}

.pa-denied h3,
.pa-pending h3 {
  margin: 0;
  font-size: 1rem;
  color: var(--text-primary);
}

.pa-denied p,
.pa-pending p {
  margin: 0;
  font-size: 0.86rem;
  max-width: 560px;
}

.pa-loading {
  padding: 30px;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
}

.pa-layout {
  display: grid;
  grid-template-columns: 290px 1fr;
  gap: 18px;
  align-items: start;
}

@media (max-width: 900px) {
  .pa-layout {
    grid-template-columns: 1fr;
  }
}

/* ── Lista de empresas ─────────────────────────────────────────────────── */

.pa-companies {
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  overflow: hidden;
}

.pa-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 11px;
  border-bottom: 1px solid var(--border);
  background: var(--slate-200);
}

.pa-search svg {
  width: 16px;
  height: 16px;
  color: var(--text-muted);
  flex: 0 0 auto;
}

.pa-search input {
  flex: 1 1;
  border: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.85rem;
  outline: none;
}

.pa-company-list {
  list-style: none;
  margin: 0;
  padding: 6px;
  max-height: 62vh;
  overflow-y: auto;
}

.pa-company {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 9px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  color: var(--text-primary);
  transition: background 0.12s ease, border-color 0.12s ease;
}

.pa-company:hover {
  background: var(--slate-100);
}

.pa-company--active {
  background: rgba(var(--accent-rgb), 0.12);
  border-color: var(--accent);
}

.pa-company-icon {
  width: 17px;
  height: 17px;
  color: var(--text-muted);
  flex: 0 0 auto;
}

.pa-company-texts {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}

.pa-company-name {
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pa-company-slug {
  font-size: 0.7rem;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pa-badge {
  font-size: 0.66rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-radius: 999px;
  padding: 2px 8px;
  border: 1px solid var(--border);
  color: var(--text-muted);
  flex: 0 0 auto;
}

.pa-badge--limit {
  color: #d97706;
  border-color: #d97706;
}

.pa-badge--all {
  color: #16a34a;
  border-color: #16a34a;
}

/* Insignia de aspecto propio de una empresa (pestaña Aspecto) */
.pa-badge--theme {
  color: var(--accent-l);
  border-color: rgba(var(--accent-rgb), 0.6);
}

.pa-empty {
  padding: 14px;
  text-align: center;
  font-size: 0.82rem;
  color: var(--text-muted);
}

/* ── Detalle de la empresa ─────────────────────────────────────────────── */

.pa-detail {
  min-width: 0;
}

.pa-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}

.pa-detail-title {
  margin: 0;
  font-size: 1.12rem;
  font-weight: 700;
  color: var(--text-primary);
}

.pa-detail-meta {
  margin: 3px 0 0;
  font-size: 0.76rem;
  color: var(--text-muted);
}

.pa-detail-meta code {
  font-size: 0.74rem;
  background: var(--slate-200);
  border-radius: 4px;
  padding: 1px 5px;
}

.pa-detail-count {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--accent);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 3px 11px;
  white-space: nowrap;
}

.pa-detail-help {
  margin: 0 0 12px;
  font-size: 0.84rem;
  color: var(--text-secondary);
}

.pa-detail-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

/* ── Aspecto por empresa ─────────────────────────────────────────────── */
.pa-theme-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 14px;
  margin: 4px 0 12px;
}

.pa-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pa-field__label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

.pa-theme-hint {
  margin: 0 0 12px;
  font-size: 0.8rem;
  line-height: 1.5;
  color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/PlatformAdmin.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,6EAA6E;;AAE7E;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,6EAA6E;;AAE7E;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B","sourcesContent":["/**\r\n * PlatformAdmin — panel de plataforma de la CMDB (solo superadmin).\r\n * Solo variables del design system (dark + light).\r\n */\r\n\r\n.platform-admin {\r\n  padding: 22px 26px 40px;\r\n  max-width: 1240px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.pa-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 24px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.pa-title {\r\n  margin: 0 0 4px;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.pa-subtitle {\r\n  margin: 0;\r\n  font-size: 0.88rem;\r\n  color: var(--text-secondary);\r\n  max-width: 640px;\r\n}\r\n\r\n.pa-summary {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pa-summary-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2px;\r\n  min-width: 96px;\r\n  padding: 8px 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: var(--bg-card);\r\n}\r\n\r\n.pa-summary-value {\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  color: var(--accent);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.pa-summary-label {\r\n  font-size: 0.7rem;\r\n  color: var(--text-muted);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  text-align: center;\r\n}\r\n\r\n.pa-tabs {\r\n  display: flex;\r\n  gap: 6px;\r\n  border-bottom: 1px solid var(--border);\r\n  margin-bottom: 18px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pa-tab {\r\n  background: transparent;\r\n  border: none;\r\n  border-bottom: 2px solid transparent;\r\n  color: var(--text-secondary);\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n  padding: 9px 14px;\r\n  cursor: pointer;\r\n  transition: color 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.pa-tab:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.pa-tab--active {\r\n  color: var(--accent);\r\n  border-bottom-color: var(--accent);\r\n}\r\n\r\n.pa-pending,\r\n.pa-denied {\r\n  border: 1px dashed var(--border);\r\n  border-radius: 12px;\r\n  padding: 26px 24px;\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.pa-denied {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 8px;\r\n  margin-top: 40px;\r\n}\r\n\r\n.pa-denied svg {\r\n  width: 34px;\r\n  height: 34px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.pa-denied h3,\r\n.pa-pending h3 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.pa-denied p,\r\n.pa-pending p {\r\n  margin: 0;\r\n  font-size: 0.86rem;\r\n  max-width: 560px;\r\n}\r\n\r\n.pa-loading {\r\n  padding: 30px;\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.pa-layout {\r\n  display: grid;\r\n  grid-template-columns: 290px 1fr;\r\n  gap: 18px;\r\n  align-items: start;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .pa-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n/* ── Lista de empresas ─────────────────────────────────────────────────── */\r\n\r\n.pa-companies {\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n  overflow: hidden;\r\n}\r\n\r\n.pa-search {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 9px 11px;\r\n  border-bottom: 1px solid var(--border);\r\n  background: var(--slate-200);\r\n}\r\n\r\n.pa-search svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  color: var(--text-muted);\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.pa-search input {\r\n  flex: 1;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  font-size: 0.85rem;\r\n  outline: none;\r\n}\r\n\r\n.pa-company-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 6px;\r\n  max-height: 62vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.pa-company {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  padding: 8px 9px;\r\n  border: 1px solid transparent;\r\n  border-radius: 8px;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  color: var(--text-primary);\r\n  transition: background 0.12s ease, border-color 0.12s ease;\r\n}\r\n\r\n.pa-company:hover {\r\n  background: var(--slate-100);\r\n}\r\n\r\n.pa-company--active {\r\n  background: rgba(var(--accent-rgb), 0.12);\r\n  border-color: var(--accent);\r\n}\r\n\r\n.pa-company-icon {\r\n  width: 17px;\r\n  height: 17px;\r\n  color: var(--text-muted);\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.pa-company-texts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  flex: 1;\r\n}\r\n\r\n.pa-company-name {\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.pa-company-slug {\r\n  font-size: 0.7rem;\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.pa-badge {\r\n  font-size: 0.66rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  border-radius: 999px;\r\n  padding: 2px 8px;\r\n  border: 1px solid var(--border);\r\n  color: var(--text-muted);\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.pa-badge--limit {\r\n  color: #d97706;\r\n  border-color: #d97706;\r\n}\r\n\r\n.pa-badge--all {\r\n  color: #16a34a;\r\n  border-color: #16a34a;\r\n}\r\n\r\n/* Insignia de aspecto propio de una empresa (pestaña Aspecto) */\r\n.pa-badge--theme {\r\n  color: var(--accent-l);\r\n  border-color: rgba(var(--accent-rgb), 0.6);\r\n}\r\n\r\n.pa-empty {\r\n  padding: 14px;\r\n  text-align: center;\r\n  font-size: 0.82rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Detalle de la empresa ─────────────────────────────────────────────── */\r\n\r\n.pa-detail {\r\n  min-width: 0;\r\n}\r\n\r\n.pa-detail-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  margin-bottom: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pa-detail-title {\r\n  margin: 0;\r\n  font-size: 1.12rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.pa-detail-meta {\r\n  margin: 3px 0 0;\r\n  font-size: 0.76rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.pa-detail-meta code {\r\n  font-size: 0.74rem;\r\n  background: var(--slate-200);\r\n  border-radius: 4px;\r\n  padding: 1px 5px;\r\n}\r\n\r\n.pa-detail-count {\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  color: var(--accent);\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  padding: 3px 11px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.pa-detail-help {\r\n  margin: 0 0 12px;\r\n  font-size: 0.84rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.pa-detail-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  margin-top: 16px;\r\n}\r\n\r\n/* ── Aspecto por empresa ─────────────────────────────────────────────── */\r\n.pa-theme-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\r\n  gap: 14px;\r\n  margin: 4px 0 12px;\r\n}\r\n\r\n.pa-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.pa-field__label {\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.pa-theme-hint {\r\n  margin: 0 0 12px;\r\n  font-size: 0.8rem;\r\n  line-height: 1.5;\r\n  color: var(--text-muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
